function isStandaloneNavigator(
  nav: Navigator,
): nav is Navigator & { standalone: boolean } {
  return "standalone" in nav;
}

export function isPwa(): boolean {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    (isStandaloneNavigator(navigator) && navigator.standalone)
  );
}
